import { render, staticRenderFns } from "./tableAllSamplesWithResults.vue?vue&type=template&id=50d685fa&scoped=true"
import script from "./tableAllSamplesWithResults.vue?vue&type=script&lang=js"
export * from "./tableAllSamplesWithResults.vue?vue&type=script&lang=js"
import style0 from "./tableAllSamplesWithResults.vue?vue&type=style&index=0&id=50d685fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d685fa",
  null
  
)

export default component.exports